import styled from "@emotion/styled";
import { getInputFieldHeightValue } from "../../../util/inputFieldBaseProps";
import { TextInputRootBoxProps, formInputTheme, getBackgroundColor } from "../../textinput/styled/formInputTheme";

export interface TextAreaStyledProps extends TextInputRootBoxProps {
    maxHeight?: string | number;
    minHeight?: string | number;
}

export const TextAreaStyled = styled("textarea")<TextAreaStyledProps>`
    background-color: ${getBackgroundColor};
    max-height: ${({ maxHeight }) => (maxHeight && maxHeight !== "none" ? maxHeight : "none")};
    word-break: break-word;

    // needed to position the error message correctly
    min-height: ${({ minHeight }) => (minHeight && minHeight !== "none" ? minHeight : "none")};

    padding: ${getPadding};

    resize: none;
    color: var(--sds--form--color--value, inherit);
    &::placeholder {
        color: ${({ themeMode }) =>
            `var(--sds--form--color--placeholder, ${formInputTheme.placeholderColor.rest(themeMode)})`};
    }
    &[aria-disabled="true"] {
        cursor: not-allowed;
    }
`;

const paddingTopVar = "--sds--textarea--padding-top";
const paddingRightVar = "--sds--textarea--padding-right";
const paddingBottomVar = "--sds--textarea--padding-bottom";
const paddingLeftVar = "--sds--textarea--padding-left";

export function getPadding({
    themeMode,
    validationState,
    isFocused,
    focusMode,
    inputFieldHeight,
}: Pick<TextAreaStyledProps, "validationState" | "isFocused" | "focusMode" | "themeMode" | "inputFieldHeight">) {
    if (validationState === "error") {
        return `
        var(${paddingTopVar}, ${formInputTheme.padding.top[getInputFieldHeightValue(themeMode, inputFieldHeight)].error(
            themeMode
        )}px)
        var(${paddingRightVar}, 5px) 
        var(${paddingBottomVar},${formInputTheme.padding.bottom[
            getInputFieldHeightValue(themeMode, inputFieldHeight)
        ].error(themeMode)}px)
        var(${paddingLeftVar},${formInputTheme.padding.default.error(themeMode)}px)`;
    } else if (isFocused && focusMode !== "keyboard") {
        return `
        var(${paddingTopVar}, ${formInputTheme.padding.top[
            getInputFieldHeightValue(themeMode, inputFieldHeight)
        ].active(themeMode)}px)
        var(${paddingRightVar}, 5px) 
        var(${paddingBottomVar},${formInputTheme.padding.bottom[
            getInputFieldHeightValue(themeMode, inputFieldHeight)
        ].active(themeMode)}px)
        var(${paddingLeftVar},${formInputTheme.padding.default.active(themeMode)}px)`;
    } else {
        return `
        var(${paddingTopVar}, ${formInputTheme.padding.top[getInputFieldHeightValue(themeMode, inputFieldHeight)].rest(
            themeMode
        )}px)
        var(${paddingRightVar}, 6px)  
        var(${paddingBottomVar},${formInputTheme.padding.bottom[
            getInputFieldHeightValue(themeMode, inputFieldHeight)
        ].rest(themeMode)}px)
        var(${paddingLeftVar},${formInputTheme.padding.default.rest(themeMode)}px)`;
    }
}
